export const notifications = {
    warning: {
        header: 'Oops, something went wrong',
        body: 'Please check your connection or try again later.',
    },
    repairingFile: {
        header: 'Optimization necessary',
        body: 'Your file is not yet optimized for 3D-printing. Please wait a moment for our optimization software to repair your file.',
    },
    technicalDifficulties: {
        header: 'Technical Difficulties',
        body:
            "Dear customer,\n because of an Software Update we're experiencing technical difficulties with the Safari Browser when uploading 3D-Files.\n " +
            'We are trying to fix the problem as soon as Possible. Thank you for your understanding.',
    },
    holiday_leave: {
        header: "Important note",
        body: "We are on holiday from December 25th, 2023 - January 7th, 2024.\nFrom January 8th, 2024 we will be there for you again as usual."
    }
};
